<!-- menu-toggle.component.html -->
<div
  class="fixed top-0 left-0 right-0 z-[1050]"
  [ngClass]="{ 'bg-lightmabe': !isHomeComponent }"
>
  <div
    class="bg-primary flex justify-between items-center shadow-md relative mt-3 md:mx-14 mx-2 rounded-[16px] p-0 min-h-[68px]"
  >
    <div class="flex w-[100%]">
      <!-- Icon Back -->
      <a
        class="items-center cursor-pointer"
        *ngIf="enableButtonBack"
        (click)="pageBack()"
      >
        <img
          src="assets/images/icon-back.svg"
          alt="Logo back"
          class="w-[40px] h-[40px] md:w-[50px] md:h-[50px] text-white"
        />
      </a>

      <!-- Logo -->
      <div
        class="flex space-x-1 w-full items-center ms-5"
        [ngClass]="{'justify-center': enableButtonBack, 'md:justify-start': enableButtonBack, }"
      >
        <img
          src="assets/images/tracking-logo.png"
          alt="Logo Mabe Tracking"
          routerLink="/"
          class="w-[165px] md:w-[210px] h-auto cursor-pointer"
        />
      </div>
    </div>
    <!-- Button menu responsive -->
    <div class="md:hidden flex items-center text-white text-sm">
      <a
        (click)="toggleSidebar()"
        class="items-center py-3 text-blue-white px-5"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M3.23828 7.5H21.2383"
            stroke="white"
            stroke-width="1.6"
            stroke-linecap="round"
          />
          <path
            d="M3.23828 12.5H21.2383"
            stroke="white"
            stroke-width="1.6"
            stroke-linecap="round"
          />
          <path
            d="M3.23828 17.5H21.2383"
            stroke="white"
            stroke-width="1.6"
            stroke-linecap="round"
          />
        </svg>
      </a>
    </div>

    <!-- Url -->
    <div class="hidden md:flex items-center text-white text-[16px] space-x-4 pe-1">
      <span class="font-semibold text-[18px]">Contáctanos:</span>
      <a
        [href]="frontSettings.URL_CONTACT_EMAIL?.url"
        [title]="frontSettings.URL_CONTACT_EMAIL?.name"
        class="hover:text-gray-200 flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14.1667 2.91675H5.83332C3.33332 2.91675 1.66666 4.16675 1.66666 7.08342V12.9167C1.66666 15.8334 3.33332 17.0834 5.83332 17.0834H14.1667C16.6667 17.0834 18.3333 15.8334 18.3333 12.9167V7.08342C18.3333 4.16675 16.6667 2.91675 14.1667 2.91675ZM14.5583 7.99175L11.95 10.0751C11.4 10.5167 10.7 10.7334 9.99999 10.7334C9.29999 10.7334 8.59166 10.5167 8.04999 10.0751L5.44166 7.99175C5.17499 7.77508 5.13332 7.37508 5.34166 7.10841C5.55832 6.84175 5.94999 6.79175 6.21666 7.00841L8.82499 9.09175C9.45832 9.60008 10.5333 9.60008 11.1667 9.09175L13.775 7.00841C14.0417 6.79175 14.4417 6.83341 14.65 7.10841C14.8667 7.37508 14.825 7.77508 14.5583 7.99175Z"
            fill="white"
          />
        </svg>
      </a>
      <a
        [href]="frontSettings.URL_CONTACT_WHATSAPP?.url"
        target="_blank"
        [title]="frontSettings.URL_CONTACT_WHATSAPP?.name"
        class="hover:text-gray-200 flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.3166 9.50829C18.0333 4.67496 13.6417 0.949968 8.58332 1.7833C5.09998 2.3583 2.30832 5.18328 1.76666 8.66662C1.44999 10.6833 1.86667 12.5916 2.77501 14.1666L2.03333 16.925C1.86666 17.55 2.44165 18.1166 3.05831 17.9416L5.77499 17.1916C7.00832 17.9166 8.44999 18.3333 9.99165 18.3333C14.6917 18.3333 18.5916 14.1916 18.3166 9.50829ZM14.0667 13.1C13.9917 13.25 13.9 13.3916 13.7833 13.525C13.575 13.75 13.35 13.9166 13.1 14.0166C12.85 14.125 12.575 14.175 12.2833 14.175C11.8583 14.175 11.4 14.075 10.925 13.8666C10.4416 13.6583 9.96667 13.3833 9.49167 13.0416C9.00834 12.6916 8.55833 12.3 8.12499 11.875C7.69166 11.4416 7.30831 10.9833 6.95831 10.5083C6.61664 10.0333 6.34166 9.55828 6.14166 9.08328C5.94166 8.60828 5.84167 8.14996 5.84167 7.71663C5.84167 7.4333 5.89166 7.1583 5.99166 6.9083C6.09166 6.64996 6.25001 6.41663 6.47501 6.2083C6.74168 5.94163 7.03332 5.81663 7.34166 5.81663C7.45832 5.81663 7.57497 5.84163 7.6833 5.89163C7.79164 5.94163 7.89166 6.01663 7.96666 6.12496L8.9333 7.49161C9.0083 7.59995 9.06665 7.69162 9.09998 7.78329C9.14165 7.87495 9.15832 7.95828 9.15832 8.04162C9.15832 8.14162 9.125 8.24163 9.06666 8.34163C9.00833 8.44163 8.93331 8.54162 8.83331 8.64162L8.51664 8.97495C8.46664 9.02495 8.45001 9.07496 8.45001 9.14162C8.45001 9.17496 8.4583 9.20829 8.46664 9.24162C8.4833 9.27495 8.49167 9.29996 8.5 9.32496C8.575 9.46662 8.70831 9.64161 8.89165 9.85828C9.08331 10.0749 9.28335 10.3 9.50001 10.5166C9.72501 10.7416 9.94167 10.9416 10.1667 11.1333C10.3833 11.3166 10.5666 11.4416 10.7083 11.5166C10.7333 11.525 10.7583 11.5416 10.7833 11.5499C10.8167 11.5666 10.85 11.5666 10.8917 11.5666C10.9667 11.5666 11.0167 11.5416 11.0667 11.4916L11.3833 11.175C11.4916 11.0666 11.5917 10.9916 11.6833 10.9416C11.7833 10.8833 11.875 10.8499 11.9833 10.8499C12.0667 10.8499 12.15 10.8666 12.2417 10.9083C12.3333 10.95 12.4333 11 12.5333 11.075L13.9167 12.0583C14.025 12.1333 14.1 12.225 14.15 12.325C14.1916 12.4333 14.2167 12.5333 14.2167 12.65C14.1667 12.7916 14.1333 12.95 14.0667 13.1Z"
            fill="white"
          />
        </svg>
      </a>
      <a
        [title]="!showPopup ? frontSettings.URL_CONTACT_PHONE?.name : ''"
        (click)="togglePopup()"
        class="hover:text-gray-200 flex items-center md:block"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.3083 15.2751C18.3083 15.5751 18.2417 15.8834 18.1 16.1834C17.9583 16.4834 17.775 16.7667 17.5333 17.0334C17.125 17.4834 16.675 17.8084 16.1667 18.0168C15.6667 18.2251 15.125 18.3334 14.5417 18.3334C13.6917 18.3334 12.7833 18.1334 11.825 17.7251C10.8667 17.3167 9.90832 16.7667 8.95832 16.0751C7.99999 15.3751 7.09166 14.6001 6.22499 13.7417C5.36666 12.8751 4.59166 11.9667 3.89999 11.0167C3.21666 10.0667 2.66666 9.11675 2.26666 8.17508C1.86666 7.22508 1.66666 6.31675 1.66666 5.45008C1.66666 4.88341 1.76666 4.34175 1.96666 3.84175C2.16666 3.33341 2.48332 2.86675 2.92499 2.45008C3.45832 1.92508 4.04166 1.66675 4.65832 1.66675C4.89166 1.66675 5.12499 1.71675 5.33332 1.81675C5.54999 1.91675 5.74166 2.06675 5.89166 2.28341L7.82499 5.00841C7.97499 5.21675 8.08332 5.40841 8.15832 5.59175C8.23332 5.76675 8.27499 5.94175 8.27499 6.10008C8.27499 6.30008 8.21666 6.50008 8.09999 6.69175C7.99166 6.88341 7.83332 7.08341 7.63332 7.28341L6.99999 7.94175C6.90832 8.03341 6.86666 8.14175 6.86666 8.27508C6.86666 8.34175 6.87499 8.40008 6.89166 8.46675C6.91666 8.53341 6.94166 8.58341 6.95832 8.63341C7.10832 8.90841 7.36666 9.26675 7.73332 9.70008C8.10832 10.1334 8.50832 10.5751 8.94166 11.0167C9.39166 11.4584 9.82499 11.8667 10.2667 12.2417C10.7 12.6084 11.0583 12.8584 11.3417 13.0084C11.3833 13.0251 11.4333 13.0501 11.4917 13.0751C11.5583 13.1001 11.625 13.1084 11.7 13.1084C11.8417 13.1084 11.95 13.0584 12.0417 12.9667L12.675 12.3417C12.8833 12.1334 13.0833 11.9751 13.275 11.8751C13.4667 11.7584 13.6583 11.7001 13.8667 11.7001C14.025 11.7001 14.1917 11.7334 14.375 11.8084C14.5583 11.8834 14.75 11.9917 14.9583 12.1334L17.7167 14.0917C17.9333 14.2417 18.0833 14.4167 18.175 14.6251C18.2583 14.8334 18.3083 15.0417 18.3083 15.2751Z"
            fill="white"
          />
        </svg>

        <!-- Popup (tooltip) -->
        <div
          *ngIf="showPopup"
          class="absolute mt-2 bg-white text-graymabe text-sm rounded-lg shadow-lg p-3 w-auto"
        >
          <p>{{ frontSettings.URL_CONTACT_PHONE?.name }}</p>
        </div>
      </a>

      <div class="flex">
        <div
          class="ms-[20px] mt-[12px] mb-[12px]"
          *ngIf="_myAccountService.isAutenticated() && !isHistoryComponent"
        >
          <button
            class="border border-white rounded-full py-3 w-[150px]"
            routerLink="/order-history"
          >
            Historial
          </button>
        </div>
        <div class="ms-[20px] me-[40px] mt-[12px] mb-[12px]">
          <app-primary-button
            [text]="!_myAccountService.isAutenticated() ? 'Mi cuenta' : 'Salir'"
            class="m-auto"
            extraClasses="w-[154px] text-[20px] font-roboto font-medium"
            (buttonClick)="closeSidebar(); checkLogin()"
          ></app-primary-button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- (sidebar) -->
<div
  [ngClass]="{ 'translate-x-full': !isSidebarOpen }"
  class="fixed top-0 right-0 w-full h-full bg-primary text-white transform transition-transform duration-300 z-[1050]"
>
  <div class="flex justify-end p-4">
    <button (click)="closeSidebar()" class="text-white focus:outline-none">
      <!-- Close sidebar -->
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  </div>

  <img
    src="assets/images/tracking-logo.png"
    alt="Logo Mabe Tracking"
    class="m-auto w-[65%] max-w-[260px] mt-12 mb-24 h-auto"
  />

  <h3 class="mx-auto font-bold text-3xl text-center">Contáctanos:</h3>

  <div class="mx-auto my-10 flex justify-center space-x-10">
    <a
      [href]="frontSettings.URL_CONTACT_EMAIL?.url"
      [title]="frontSettings.URL_CONTACT_EMAIL?.name"
      class="hover:text-gray-200 flex items-center px-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M14.1667 2.91675H5.83332C3.33332 2.91675 1.66666 4.16675 1.66666 7.08342V12.9167C1.66666 15.8334 3.33332 17.0834 5.83332 17.0834H14.1667C16.6667 17.0834 18.3333 15.8334 18.3333 12.9167V7.08342C18.3333 4.16675 16.6667 2.91675 14.1667 2.91675ZM14.5583 7.99175L11.95 10.0751C11.4 10.5167 10.7 10.7334 9.99999 10.7334C9.29999 10.7334 8.59166 10.5167 8.04999 10.0751L5.44166 7.99175C5.17499 7.77508 5.13332 7.37508 5.34166 7.10841C5.55832 6.84175 5.94999 6.79175 6.21666 7.00841L8.82499 9.09175C9.45832 9.60008 10.5333 9.60008 11.1667 9.09175L13.775 7.00841C14.0417 6.79175 14.4417 6.83341 14.65 7.10841C14.8667 7.37508 14.825 7.77508 14.5583 7.99175Z"
          fill="white"
        />
      </svg>
    </a>
    <a
      [href]="frontSettings.URL_CONTACT_WHATSAPP?.url"
      [title]="frontSettings.URL_CONTACT_WHATSAPP?.name"
      target="_blank"
      class="hover:text-gray-200 flex items-center px-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M18.3166 9.50829C18.0333 4.67496 13.6417 0.949968 8.58332 1.7833C5.09998 2.3583 2.30832 5.18328 1.76666 8.66662C1.44999 10.6833 1.86667 12.5916 2.77501 14.1666L2.03333 16.925C1.86666 17.55 2.44165 18.1166 3.05831 17.9416L5.77499 17.1916C7.00832 17.9166 8.44999 18.3333 9.99165 18.3333C14.6917 18.3333 18.5916 14.1916 18.3166 9.50829ZM14.0667 13.1C13.9917 13.25 13.9 13.3916 13.7833 13.525C13.575 13.75 13.35 13.9166 13.1 14.0166C12.85 14.125 12.575 14.175 12.2833 14.175C11.8583 14.175 11.4 14.075 10.925 13.8666C10.4416 13.6583 9.96667 13.3833 9.49167 13.0416C9.00834 12.6916 8.55833 12.3 8.12499 11.875C7.69166 11.4416 7.30831 10.9833 6.95831 10.5083C6.61664 10.0333 6.34166 9.55828 6.14166 9.08328C5.94166 8.60828 5.84167 8.14996 5.84167 7.71663C5.84167 7.4333 5.89166 7.1583 5.99166 6.9083C6.09166 6.64996 6.25001 6.41663 6.47501 6.2083C6.74168 5.94163 7.03332 5.81663 7.34166 5.81663C7.45832 5.81663 7.57497 5.84163 7.6833 5.89163C7.79164 5.94163 7.89166 6.01663 7.96666 6.12496L8.9333 7.49161C9.0083 7.59995 9.06665 7.69162 9.09998 7.78329C9.14165 7.87495 9.15832 7.95828 9.15832 8.04162C9.15832 8.14162 9.125 8.24163 9.06666 8.34163C9.00833 8.44163 8.93331 8.54162 8.83331 8.64162L8.51664 8.97495C8.46664 9.02495 8.45001 9.07496 8.45001 9.14162C8.45001 9.17496 8.4583 9.20829 8.46664 9.24162C8.4833 9.27495 8.49167 9.29996 8.5 9.32496C8.575 9.46662 8.70831 9.64161 8.89165 9.85828C9.08331 10.0749 9.28335 10.3 9.50001 10.5166C9.72501 10.7416 9.94167 10.9416 10.1667 11.1333C10.3833 11.3166 10.5666 11.4416 10.7083 11.5166C10.7333 11.525 10.7583 11.5416 10.7833 11.5499C10.8167 11.5666 10.85 11.5666 10.8917 11.5666C10.9667 11.5666 11.0167 11.5416 11.0667 11.4916L11.3833 11.175C11.4916 11.0666 11.5917 10.9916 11.6833 10.9416C11.7833 10.8833 11.875 10.8499 11.9833 10.8499C12.0667 10.8499 12.15 10.8666 12.2417 10.9083C12.3333 10.95 12.4333 11 12.5333 11.075L13.9167 12.0583C14.025 12.1333 14.1 12.225 14.15 12.325C14.1916 12.4333 14.2167 12.5333 14.2167 12.65C14.1667 12.7916 14.1333 12.95 14.0667 13.1Z"
          fill="white"
        />
      </svg>
    </a>
    <a
      [href]="frontSettings.URL_CONTACT_PHONE?.url"
      [title]="frontSettings.URL_CONTACT_PHONE?.name"
      class="hover:text-gray-200 flex items-center px-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M18.3083 15.2751C18.3083 15.5751 18.2417 15.8834 18.1 16.1834C17.9583 16.4834 17.775 16.7667 17.5333 17.0334C17.125 17.4834 16.675 17.8084 16.1667 18.0168C15.6667 18.2251 15.125 18.3334 14.5417 18.3334C13.6917 18.3334 12.7833 18.1334 11.825 17.7251C10.8667 17.3167 9.90832 16.7667 8.95832 16.0751C7.99999 15.3751 7.09166 14.6001 6.22499 13.7417C5.36666 12.8751 4.59166 11.9667 3.89999 11.0167C3.21666 10.0667 2.66666 9.11675 2.26666 8.17508C1.86666 7.22508 1.66666 6.31675 1.66666 5.45008C1.66666 4.88341 1.76666 4.34175 1.96666 3.84175C2.16666 3.33341 2.48332 2.86675 2.92499 2.45008C3.45832 1.92508 4.04166 1.66675 4.65832 1.66675C4.89166 1.66675 5.12499 1.71675 5.33332 1.81675C5.54999 1.91675 5.74166 2.06675 5.89166 2.28341L7.82499 5.00841C7.97499 5.21675 8.08332 5.40841 8.15832 5.59175C8.23332 5.76675 8.27499 5.94175 8.27499 6.10008C8.27499 6.30008 8.21666 6.50008 8.09999 6.69175C7.99166 6.88341 7.83332 7.08341 7.63332 7.28341L6.99999 7.94175C6.90832 8.03341 6.86666 8.14175 6.86666 8.27508C6.86666 8.34175 6.87499 8.40008 6.89166 8.46675C6.91666 8.53341 6.94166 8.58341 6.95832 8.63341C7.10832 8.90841 7.36666 9.26675 7.73332 9.70008C8.10832 10.1334 8.50832 10.5751 8.94166 11.0167C9.39166 11.4584 9.82499 11.8667 10.2667 12.2417C10.7 12.6084 11.0583 12.8584 11.3417 13.0084C11.3833 13.0251 11.4333 13.0501 11.4917 13.0751C11.5583 13.1001 11.625 13.1084 11.7 13.1084C11.8417 13.1084 11.95 13.0584 12.0417 12.9667L12.675 12.3417C12.8833 12.1334 13.0833 11.9751 13.275 11.8751C13.4667 11.7584 13.6583 11.7001 13.8667 11.7001C14.025 11.7001 14.1917 11.7334 14.375 11.8084C14.5583 11.8834 14.75 11.9917 14.9583 12.1334L17.7167 14.0917C17.9333 14.2417 18.0833 14.4167 18.175 14.6251C18.2583 14.8334 18.3083 15.0417 18.3083 15.2751Z"
          fill="white"
        />
      </svg>
    </a>
  </div>

  <div class="">
    <div
      class="px-5 py-3"
      *ngIf="_myAccountService.isAutenticated() && !isHistoryComponent"
    >
      <button
        class="border border-white rounded-full py-3 w-full"
        (click)="closeSidebar()"
        routerLink="/order-history"
      >
        Historial
      </button>
    </div>
    <div class="px-5 py-3">
      <app-primary-button
        [text]="!_myAccountService.isAutenticated() ? 'Mi cuenta' : 'Salir'"
        class="m-auto"
        extraClasses="w-full"
        (buttonClick)="closeSidebar(); checkLogin()"
      ></app-primary-button>
    </div>
  </div>
</div>

<!-- Background -->
<div
  [ngClass]="{ hidden: !isSidebarOpen }"
  class="fixed inset-0 bg-black opacity-50 z-40"
></div>

<div
  *ngIf="showModalSession"
  class="fixed z-[1200] w-full h-full modal-session flex items-center justify-center top-0 left-0"
>
  <div class="bg-white rounded-xl h-fit p-10 m-10 text-center">
    <h2 class="text-xl font-roboto">¿Estás seguro de salir de tu cuenta?</h2>
    <div class="flex justify-center items-center mt-5 space-x-5">
      <button
        (click)="onConfirm()"
        class="min-w-36 py-2 px-5 bg-secondary text-white rounded-xl"
      >
        Si
      </button>
      <button
        (click)="onCancel()"
        class="min-w-36 py-2 px-5 border border-secondary text-secondary rounded-xl"
      >
        No
      </button>
    </div>
  </div>
</div>
